import React from 'react'

const DEFAULT_COLORS = {
  active: '#FFFFFF',
  inactive: '#2D264B',
  stroke: '#FFFFFF',
}

const AudienceAndVariableIcon = ({
  isActive,
  color,
  width = 24,
  height = 24,
  ...props
}) => {
  const styles = {
    stroke: color
      ? DEFAULT_COLORS.stroke
      : isActive
      ? DEFAULT_COLORS.active
      : DEFAULT_COLORS.inactive,
    fill: color || 'none',
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={styles.fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.59151 15.207C13.2805 15.207 16.4335 15.766 16.4335 17.999C16.4335 20.232 13.3015 20.807 9.59151 20.807C5.90151 20.807 2.74951 20.253 2.74951 18.019C2.74951 15.785 5.88051 15.207 9.59151 15.207Z"
        stroke={styles.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.59157 12.02C7.16957 12.02 5.20557 10.057 5.20557 7.635C5.20557 5.213 7.16957 3.25 9.59157 3.25C12.0126 3.25 13.9766 5.213 13.9766 7.635C13.9856 10.048 12.0356 12.011 9.62257 12.02H9.59157Z"
        stroke={styles.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4832 10.8823C18.0842 10.6573 19.3172 9.28326 19.3202 7.62026C19.3202 5.98126 18.1252 4.62126 16.5582 4.36426"
        stroke={styles.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5955 14.7324C20.1465 14.9634 21.2295 15.5074 21.2295 16.6274C21.2295 17.3984 20.7195 17.8984 19.8955 18.2114"
        stroke={styles.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default AudienceAndVariableIcon
